var _style, _circle, _path, _path2, _g, _circle2, _g2, _g3, _g4, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#A2001D;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#496E2D;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,44.5C152.8,16.4,202.5,0,256,0s103.2,16.4,144.3,44.5L256,55.7L111.7,44.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,256l-16.3-16.3l-4.3,7.8L256,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,75C-25,175-25,337,75,437c41.3-41.3,81-81,181-181L75,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M437,75c100,100,100,262.1,0,362c-41.3-41.3-81-81-181-181L437,75z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256,
    cy: 256,
    r: 89
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,167l20,61.4h64.6l-52.3,38l20,61.4l-52.3-38l-52.3,38l20-61.4l-52.3-38H236L256,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C256,0,255.9,0,256,0L256,0C256.1,0,256,0,256,0L256,0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.1,0h-0.2C185.3,0,121.3,28.7,75,75h362C390.7,28.7,326.7,0,256.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,437c46.3,46.3,110.3,75,181,75s134.7-28.6,181-75H75z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,27.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8L256,53.3l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L256,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.9,27.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L193.9,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.1,27.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L318.1,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,450.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L256,450.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.9,450.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L193.9,450.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.1,450.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L318.1,450.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78,251.8c6.6,10.4,3.5,24.1-6.9,30.7c-10.4,6.6-24.1,3.5-30.7-6.9c-11.9-18.8-5-49.5-5-49.5 S66.1,233,78,251.8L78,251.8z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65.1,
    cy: 273.1,
    r: 11.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.b4541d8042f01670ffaa4ffc74898e47.svg";
export { ForwardRef as ReactComponent };